<template>
  <div class="rounded">
    <div class="bg-grey-85 p-3">
      <template v-if="$slots.header">
        <slot name="header" />
      </template>

      <div
        v-else
        class="text-warning-60 font-bold"
      >
        {{ title }}
      </div>
    </div>

    <div class="p-3 bg-white">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
